import styled, { css } from 'styled-components';

interface IImageWrapperProps {
  clickEneabled?: boolean;
}

export const Container = styled.div`
  flex: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  width: 100%;
  background-color: ${props => props.theme.colors.dark['dark+1']};
  height: 194px;
  /* border-bottom: 1px solid ${props => props.theme.colors.dark['dark+4']}; */
  padding: 32px 56px 16px 56px;
  display: flex;
  flex-direction: column;

  > div:nth-child(1) {
    display: flex;
    margin-top: 24px;
    flex: 1;
    width: 100%;
    max-width: 752px;
    margin-left: auto;
    margin-right: auto;

    > button {
      display: none;
    }
  }

  @media only screen and (max-width: 768px) {
    padding: 16px 32px;
  }

  @media only screen and (max-width: 600px) {
    padding: 16px;
    height: 284px;

    > div:nth-child(1) {
      flex-direction: column;
      position: relative;

      > button {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }
`;

export const ImageWrapper = styled.div<IImageWrapperProps>`
  width: 150px;
  position: relative;

  div {
    position: absolute;
    z-index: 5;
    width: 150px;
    height: 150px;
    border-radius: 75px;
    background: linear-gradient(
      180deg,
      rgba(43, 43, 43, 0) 57.27%,
      rgba(43, 43, 43, 0.7) 81.74%,
      #2b2b2b 100%
    );
    display: none;
    justify-content: center;
    align-items: flex-end;

    strong {
      color: ${props => props.theme.colors.light.light0};
      margin-bottom: 16px;
    }
  }

  img {
    width: 150px;
    height: 150px;
    position: absolute;
    z-index: 0;
    border-radius: 75px;
    border: 1px solid ${props => props.theme.colors.dark['dark+4']};
  }

  ${props =>
    props.clickEneabled &&
    css`
      cursor: pointer;

      div {
        display: flex;
      }
    `}

  @media only screen and (max-width: 600px) {
    width: 110px;
    height: 110px;
    align-self: center;

    img,
    div {
      width: 110px;
      height: 110px;
    }
  }
`;

export const UserInformationsHeader = styled.div`
  display: flex;
  flex: 1;
  margin-left: 40px;
  align-items: flex-end;

  div {
    display: flex;
    flex-direction: column;

    div {
      display: flex;
      width: 100%;
      flex-direction: row;
      width: 100%;
      align-items: center;

      @media only screen and (max-width: 600px) {
        flex-direction: column;
        h5 {
          margin-right: 0px;
        }
      }

      h5 {
        margin-bottom: 0px;
        margin-right: 16px;
      }

      span {
        font-size: ${props => props.theme.typograph.sizes.small}px;
        font-weight: ${props => props.theme.typograph.weights.medium};
        color: ${props => props.theme.colors.danger};

        &::before {
          content: '';
          width: 8px;
          height: 8px;
          background-color: ${props => props.theme.colors.danger};
          border-radius: 4px;
          margin-right: 8px;
          display: inline-block;
        }
      }
    }

    p {
      color: ${props => props.theme.colors.light['light-2']};
    }

    p:last-child {
      margin-top: 16px;
    }
  }

  button {
    margin-left: auto;
  }

  @media only screen and (max-width: 600px) {
    margin: 0 auto !important;
    text-align: center;

    button {
      display: none;
    }
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  margin-top: 80px;
  margin-bottom: 40px;
  padding: 0px 56px;

  @media only screen and (max-width: 768px) {
    margin-top: 56px;
    padding: 0px 32px;
  }
  @media only screen and (max-width: 600px) {
    margin-top: 32px;
    padding: 0px 16px;
  }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 752px;
  margin-left: auto;
  margin-right: auto;
`;

export const SessionItems = styled.ul`
  width: 100%;
  margin-top: 16px;

  li {
    list-style: none;
    width: 100%;
    margin-bottom: 8px;

    &:last-child {
      margin-bottom: 0px;
    }

    small {
      color: ${props => props.theme.colors.primary.primary0};
    }
  }
`;

export const UserNotFoundContainer = styled.div`
  padding: 32px 56px;
  flex: 1;
  display: flex;
  flex-direction: column;

  > div:nth-child(2) {
    width: 100%;
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    img {
      width: 300px;
    }

    h6 {
      margin-top: 24px;
      text-align: center;
    }
  }
  @media only screen and (max-width: 768px) {
    padding: 16px 32px;
  }
  @media only screen and (max-width: 600px) {
    padding: 16px 16px;
  }
`;

export const ActionButtonAvatar = styled.div`
  width: 100%;
  display: flex;
  padding: 16px;
  transition: background-color 0.2s;
  cursor: pointer;

  color: ${props => props.theme.colors.dark.dark0};

  span {
    font-size: 16px;
    margin-left: 16px;
  }

  &:hover {
    background-color: ${props => props.theme.colors.light['light-1']};
  }
`;
